import React from 'react'
import {Dialog, DialogBackdrop, DialogPanel} from '@headlessui/react'
import modalStateStore from '../../../services/aggie/stores/modalStateStore'

export default function GlobalModalComponent() {
	const {resetGlobalModalContent, getGlobalModalContent} = modalStateStore()

	return (
		<Dialog open={getGlobalModalContent() !== null} onClose={resetGlobalModalContent} className="relative z-[9999]">
			<DialogBackdrop
				transition
				className="fixed inset-0 bg-aggie-pink/90 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
			/>

			<div className="fixed inset-0 z-[999] w-screen overflow-y-auto">
				<div className="flex min-h-full items-end justify-center text-center sm:items-center">
					<DialogPanel
						transition
						className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4
						data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-2 sm:w-full
						sm:max-w-5xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
					>
						{/* Modal Content Here */}
						{getGlobalModalContent()}
					</DialogPanel>
				</div>
			</div>
		</Dialog>
	)
}
